// "Grupo do usuário" (accountType) da sessão atual, espelhado pelo
// AuthProvider — para services (fora de React) que precisam decidir o
// caminho de uma chamada. Cliente ("usuario") é limitCommands/
// deviceReadonly no Traccar (segurança 2026-09-24, ver
// client-traccar-restrictions.ts no backend): comandos e renomear passam
// pelo GPS Drive Backend, nunca direto no Traccar.
let currentAccountType: string | null = null;

export function setCurrentAccountType(accountType: string | null): void {
  currentAccountType = accountType;
}

export function isClientSession(): boolean {
  return currentAccountType === "usuario";
}
